import "./styles.scss";

import { useTranslation } from "react-i18next";

import Select from "../../index";

import task_priority_data from "libs/task_priority_data.json";

import { ReactComponent as FlagIcon } from "assets/icons/new/flag.svg";

const Priority = ({
  labelCta,
  selected,
  optionFilters,
  forceBottom,
  isCompletelyDisabled,
  onChange,
}) => {
  const { t } = useTranslation();

  return (
    <Select
      variant="priority"
      label={t("Priority")}
      labelCta={labelCta}
      placeholder={{
        icon: <FlagIcon />,
        label: t("Select priority"),
      }}
      options={task_priority_data
        .filter((item) => !optionFilters?.includes(item.key))
        .map((item) => ({
          ...item,
          variant: item?.color,
          icon: <FlagIcon />,
          label: t(item.label),
        }))}
      selected={selected}
      value={selected?.value}
      forceBottom={forceBottom}
      isCompletelyDisabled={isCompletelyDisabled}
      onChange={
        typeof onChange === "function"
          ? (option) => onChange(option)
          : undefined
      }
    />
  );
};

export default Priority;
